import React, {useEffect, useState} from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import agentsActions from "../../store/actions/agents";
import configActions from "../../store/actions/config";
import {useDispatch, useSelector} from "react-redux";
import InputMask from "react-input-mask";
import axios from "axios";

const recaptchaRef = React.createRef();


const ModalContactAgent = () => {
    const agentsStore = useSelector((store) => store.agentsStore);
    const configStore = useSelector((store) => store.configStore);
    const dispatch = useDispatch();

    const [formField, setFormField] = useState('email');
    const [formError, setFormError] = useState(null);
    const [currentTopic, setCurrentTopic] = useState('');
    const [recaptchaValue, setRecaptchaValue] = useState('');
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    const setMessageValue = (value) => {
        dispatch(configActions.setFormMessage(value));
        dispatch(configActions.setFormMessageError(''));
    }
    const setPolicyValue = (value) => {
        dispatch(configActions.setFormPolicy(value));
    }
    const setPhoneValue = (value) => {
        dispatch(configActions.setFormPhone(value));
        dispatch(configActions.setFormPhoneError(''));
    }
    const setEmailValue = (value) => {
        dispatch(configActions.setFormEmail(value));
        dispatch(configActions.setFormEmailError(''));
    }
    const setNameValue = (value) => {
        dispatch(configActions.setFormName(value));
        dispatch(configActions.setFormNameError(''));
    }
    const setCaptcha = () => {
        setRecaptchaValue(recaptchaRef.current.getValue());
    }

    const agent = agentsStore.currentAgent;

    const modalCLose = () => {
        let value = ''
        dispatch(configActions.setFormTopic(''));
        dispatch(configActions.setFormMessage(value));
        dispatch(configActions.setFormMessageError(''));
        dispatch(configActions.setFormPolicy(value));
        dispatch(configActions.setFormPhone(value));
        dispatch(configActions.setFormPhoneError(''));
        dispatch(configActions.setFormEmail(value));
        dispatch(configActions.setFormEmailError(''));
        dispatch(configActions.setFormName(value));
        dispatch(configActions.setFormNameError(''));
        dispatch(agentsActions.setModalOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    const formSubmit = (event) => {
        event.preventDefault();
        dispatch(configActions.setFormMessageError(''));
        dispatch(configActions.setFormEmailError(''));
        dispatch(configActions.setFormPhoneError(''));
        dispatch(configActions.setFormNameError(''));

        let formValid = true;
        let formErrorList = [];
        setFormError('');

        if (configStore.formMessage.length < 10) {
            formValid = false;
            formErrorList.push('form-message');
            dispatch(configActions.setFormMessageError('Enter your message'));
        }

        if (formField === 'email') {
            if (configStore.formEmail.length < 1) {
                formValid = false;
                formErrorList.push('form-email');
                dispatch(configActions.setFormEmailError('This field is required'));
            }
        } else if (formField === 'phone') {
            if (configStore.formPhone.length < 1){
                formValid = false;
                formErrorList.push('form-phone');
                dispatch(configActions.setFormPhoneError('This field is required'));
            }
        }

        if (configStore.formEmail.length > 0 && !configStore.formEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)){
            formValid = false;
            formErrorList.push('form-email');
            dispatch(configActions.setFormEmailError('Enter correct email'));
        }

        if (configStore.formPhone.length > 0 && configStore.formPhone.toString().slice(-1) === '_') {
            formValid = false;
            formErrorList.push('form-phone');
            dispatch(configActions.setFormPhoneError('Enter correct phone'));
        }

        if (configStore.formName.length < 3) {
            formValid = false;
            formErrorList.push('form-name');
            dispatch(configActions.setFormNameError('Enter your name'));
        }

        if (formValid) {
            sendFormAgent()
            window.grecaptcha.reset();
        } else {
            document.getElementById(formErrorList[0]).scrollIntoView({block: "center", behavior: "smooth"});
        }
    }

    useEffect(() => {
        const NAME_FROM_BACK = "contact_form_contact_agent_topic";
        
        axios.get(`${process.env.REACT_APP_API_BASE_URI}settings`)
            .then((response) => {
                const topics = response.data['hydra:member'];
                const currentTopic = topics.find((topic) => topic.name === NAME_FROM_BACK);

                setCurrentTopic(currentTopic);
            });
    }, []);

    const sendFormAgent = () => {
        dispatch(configActions.setContactAgentLoading(true))
        let contactPreference = 0;
        const today = new Date().toJSON();
        const data = {
            "topic": "api/email_topics/"+currentTopic.value,
            "subject": "Contact Agent",
            "content": configStore.formMessage,
            "sentFrom": agentsStore.currentAgent.id + '',
            "name": configStore.formName,
            "number": configStore.formPolicy,
            "contactPreference": contactPreference,
            "phone": configStore.formPhone,
            "email": configStore.formEmail,
            "createdAt": today,
            "updatedAt": today,
        };

        axios.post(`${process.env.REACT_APP_API_BASE_URI}email_histories`, data, { headers })
            .then(() => formResult()).catch((err) => formError(err));

        const formResult = () => {
            dispatch(configActions.setFormTopic(''));
            dispatch(configActions.setFormMessage(''));
            dispatch(configActions.setFormPolicy(''));
            dispatch(configActions.setFormPhone(''));
            dispatch(configActions.setFormEmail(''));
            dispatch(configActions.setFormName(''));
            window.grecaptcha.reset();
            dispatch(agentsActions.setModalOpen(false));
            dispatch(configActions.setModalSuccessOpen(true));
            document.getElementsByTagName('body')[0].classList.add('modal-open');
            dispatch(configActions.setContactAgentLoading(false))
        }

        const formError = (err) => {
            console.log(err)
            setFormError('An error occurred, please try again later')
            dispatch(configActions.setContactAgentLoading(false))
        }
    }

    return (
        <div className="modal" id="contact-agent-modal">
            <div className="modal-overlay"/>
            <div className="modal-block">
                <button
                    type='button'
                    className='modal-close'
                    onClick={() => {modalCLose()}}
                >
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} alt="close"/>
                </button>
                <div className="modal-content">
                    <div className="modal-heading">
                        <div className="modal-title">Contact Agent</div>
                    </div>
                    <div className='modal-agent-info'>
                        <img className='modal-agent-image' src={agent.image.webPath} alt=""/>
                        <p className='modal-agent-name'>
                            {agent.firstName && (
                                <span>{agent.firstName}</span>
                            )}
                            {agent.middleName && (
                                <span> {agent.middleName}</span>
                            )}
                            {agent.lastName && (
                                <span> {agent.lastName}</span>
                            )}
                        </p>
                    </div>
                    <form onSubmit={(ev) => {formSubmit(ev)}} className="form">
                        <div className={`form-group ${configStore.formMessageError.length > 0 ? 'error' : ''}`} id="form-message">
                            <div className="label">Describe your question</div>
                            <textarea
                                placeholder='Enter question'
                                className='form-textarea'
                                onChange={(ev) => setMessageValue(ev.target.value)}
                                value={configStore.formMessage}
                            />
                            {configStore.formMessageError.length > 0 &&
                            <div className="input-error">{configStore.formMessageError}</div>
                            }
                        </div>
                        <div className="form-group">
                            <div className="label">Your policy or account number (optional)</div>
                            <input
                                placeholder='Enter related policy or account number'
                                className='form-input'
                                onChange={(ev) => setPolicyValue(ev.target.value)}
                                value={configStore.formPolicy}
                            />
                        </div>
                        <div className="form-group">
                            <div className="label">What is your preferred method of contact?</div>
                            <div className='form-radio-group'>
                                <label className='form-radio'>
                                    <input
                                        type="radio"
                                        name="contact"
                                        value="email"
                                        className='form-radio'
                                        onChange={(e) => (setFormField(e.target.value))}
                                        defaultChecked
                                    />
                                    <div className="radio-box"/>
                                    <div className="radio-text">By email</div>
                                </label>
                                <label className='form-radio'>
                                    <input
                                        type="radio"
                                        name="contact"
                                        value="phone"
                                        className='form-radio'
                                        onChange={(e) => (setFormField(e.target.value))}
                                    />
                                    <div className="radio-box"/>
                                    <div className="radio-text">By telephone</div>
                                </label>
                            </div>
                        </div>
                        <div className={`form-group ${configStore.formPhoneError.length > 0 ? 'error' : ''}`} id="form-phone">
                            <div className="label">Your phone number</div>
                            <InputMask
                                mask="(999) 999-9999"
                                className='form-input'
                                placeholder='(555) 555-5555'
                                onChange={(ev) => setPhoneValue(ev.target.value)}
                                value={configStore.formPhone}
                            />
                            {configStore.formPhoneError.length > 0 &&
                            <div className="input-error">{configStore.formPhoneError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formEmailError.length > 0 ? 'error' : ''}`} id="form-email">
                            <div className="label">Your email</div>
                            <input
                                placeholder='Enter your email address'
                                className='form-input'
                                onChange={(ev) => setEmailValue(ev.target.value)}
                                value={configStore.formEmail}
                            />
                            {configStore.formEmailError.length > 0 &&
                            <div className="input-error">{configStore.formEmailError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formNameError.length > 0 ? 'error' : ''}`} id="form-name">
                            <div className="label">Your name</div>
                            <input
                                placeholder='Enter your name'
                                className='form-input'
                                onChange={(ev) => setNameValue(ev.target.value)}
                                value={configStore.formName}
                            />
                            {configStore.formNameError.length > 0 &&
                            <div className="input-error">{configStore.formNameError}</div>
                            }
                        </div>
                        <div className="form-captcha">
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size="normal"
                                sitekey="6Ldn930UAAAAACn_tkcxOq1t7Ku9j24GuSrgwbTL"
                                onChange={() => {setCaptcha()}}
                            />
                        </div>
                        <button type='submit'
                                className={`form-submit button-gradient 
                                    ${recaptchaValue.length < 1 ? 'disabled' : ''}
                                    ${configStore.isContactAgentLoading ? 'is-loading' : ''}`} >
                            <span>Send</span>
                        </button>
                        <div className="form-error">{formError}</div>
                    </form>
                </div>
            </div>
        </div>
    );
}


export default ModalContactAgent;
